import _ from 'lodash';
import { getAxiosClient } from '~src/api';
import { onErrorShowMessage } from '~src/errors';
import { getState } from '~src/state';
import { getMetadata } from '~loader/loader-utils';
import { trackEvent } from '~src/tracking';
import { startRemovebgLoader } from './startRemovebgLoader';
import { stopAiLoader } from '~core/aiLoader';
import { showBlurBgDialog } from './showBlurBgDialog';
import { prepareImageForEditing } from '~core/image';
import { isPlaceholderEditing } from '~core/magicFrame';
import { handleTabImagesAI } from '~src/sidebar/index';
import { checkAiCreditsBeforeUse } from '~core/aiCredits';

export const blurBg = async () => {
  const startTime = performance.now();
  const trackingEventName = 'AI BlurBG';

  // Check credits before starting the operation
  const hasCredits = await checkAiCreditsBeforeUse({
    featureName: 'BlurBG',
    requiredCredits: 1,
  });

  if (!hasCredits) {
    return;
  }

  startRemovebgLoader({ isBlurBg: true });

  let selection = window.canvas.getActiveObject();
  if (selection.type === 'MagicFrame') {
    selection = selection.editingImg;
  }

  if (isPlaceholderEditing(selection)) {
    return;
  }

  const imageUrl = await prepareImageForEditing(selection, false);
  if (!imageUrl) {
    console.error('No image URL found in current selection', selection);
    return;
  }

  const httpClient = await getAxiosClient();

  const metadata = getMetadata();

  const data = {
    image_url: imageUrl,
    canvasId: window.editorLoader.canvasId,
    note: JSON.stringify(
      Object.assign({}, metadata, {
        canvasId: window.editorLoader.canvasId,
      })
    ),
    skipAttachment: true,
  };

  const servizio = getState('selected.servizio', {});

  if (servizio.objectId) {
    data.servizioId = servizio.objectId;
  }

  let response;

  try {
    response = await httpClient.post(
      `${process.env.REMOVEBG_API_URL}/removebg`,
      data
    );
  } catch (err) {
    trackEvent(trackingEventName, {
      success: false,
      error_status: _.get(err, 'response.status'),
      time_taken: parseInt(performance.now() - startTime, 10),
    });
    stopAiLoader();
    return onErrorShowMessage();
  }

  // Refresh AI credits display
  handleTabImagesAI();

  // Show blur options dialog for user to select blur intensity
  showBlurBgDialog(imageUrl, response.data.image, startTime);
};
